import { ShowroomForm } from "./ShowroomForm.jsx";
import { FormProvider } from "./FormContext.jsx";

/**
 * ShowroomFormArea is a functional component responsible for wrapping the showroom form
 * within the context of a form provider.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {boolean} props.smallTeam - The project team.
 * @param {Object} props.projectFormDefinition - The definition of the form including its fields.
 * @param {Object} props.entry - The entry data to be used in the form.
 * @returns {JSX.Element} The rendered form area component.
 */
export const ShowroomFormArea = ({
  smallTeam,
  projectFormDefinition,
  entry,
}) => {
  const { fields } = projectFormDefinition;

  return (
    <FormProvider fields={fields}>
      <ShowroomForm
        entry={entry}
        smallTeam={smallTeam}
        projectFormDefinition={projectFormDefinition}
      />
    </FormProvider>
  );
};
